import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import ErrorBoundary from '@/components/error-boundary'
import './index.css'
import { cleanupBrokenRecords } from '@/lib/store'
import { startCloudSync } from '@/lib/sync'

// 起動時に一度だけ既知の壊れレコードをクリーンアップ
try { cleanupBrokenRecords(); } catch (_e) { /* ignore: best-effort cleanup */ }
// Firestore 同期（環境変数が未設定なら何もしない）
try { void startCloudSync(); } catch (_e) { /* ignore: optional background sync */ }

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
